import { systemRoutes } from './shared/routes/routes';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [RouterModule.forRoot(systemRoutes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
